import {
    GET_EMAIL_TEMPLATE,
    GET_EMAIL_TEMPLATE_ID,
    SET_EMAIL_TEMPLATE
} 
from '../actions/actionTypes';

const initialState = {
    emailTemplateAll: [],
    emailTemplate:null,
    saveEmailTemplate:null
};

function EmailTemplateRedux(state = initialState, action) {
    switch (action.type) {
        case GET_EMAIL_TEMPLATE:
            return {
                ...state,
                emailTemplateAll: action.payload
            };
        case GET_EMAIL_TEMPLATE_ID:
            return {
                ...state,
                emailTemplate: action.payload
            };
        case SET_EMAIL_TEMPLATE:
            return {
                ...state,
                saveEmailTemplate: action.payload
            };
        default:
            return state;
    }
}

export default EmailTemplateRedux;